const IMAGE_BASE_URL = "https://dibru-files.s3.ap-south-1.amazonaws.com/";

export { IMAGE_BASE_URL };
